import React from 'react'
import { cn } from './cn'

export function Tabs({ tabs, activeId, onChange, className }) {
  return (
    <nav className={cn('flex gap-1 border-b border-muted dark:border-muted-dark', className)} aria-label="Tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab)}
          className={cn(
            'flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors',
            activeId === tab.id
              ? 'border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400'
              : 'border-transparent text-text-muted hover:border-secondary-300 hover:text-secondary-700 dark:text-text-muted-dark dark:hover:text-secondary-200'
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </nav>
  )
}
